export default __webpack_public_path__ + "static/media/kiosco.b45dcaa2.svg";